export const ALIGN = {
  vertical: "vertical",
  horizontal: "horizontal",
};
